(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-sb-slide]')];
    if (slides.length <= 2) return;
    const controls = root.querySelector('.sb-hero-controls');
    controls.hidden = false;
    const button = root.querySelector('[data-sb-pause]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduced.matches, cursor = 0, hovering = false;
    const updateButton = () => {
      button.textContent = paused ? 'Start' : 'Pause';
      button.setAttribute('aria-label', paused ? 'Automatischen Produktwechsel starten' : 'Automatischen Produktwechsel pausieren');
    };
    const advance = direction => {
      cursor = (cursor + direction * 2 + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const second = index === (cursor + 1) % slides.length;
        slide.hidden = index !== cursor && !second;
        slide.classList.toggle('sb-hero-second', second);
      });
    };
    updateButton();
    root.querySelector('[data-sb-prev]').addEventListener('click', () => advance(-1));
    root.querySelector('[data-sb-next]').addEventListener('click', () => advance(1));
    button.addEventListener('click', () => { paused = !paused; updateButton(); });
    root.addEventListener('pointerenter', () => { hovering = true; });
    root.addEventListener('pointerleave', () => { hovering = false; });
    reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; updateButton(); } });
    const timer = window.setInterval(() => {
      if (!root.isConnected) { window.clearInterval(timer); return; }
      if (paused || hovering || document.hidden || root.contains(document.activeElement)) return;
      advance(1);
    }, 5000);
  }
  const scan = () => document.querySelectorAll('[data-sb-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
